export default {"src":"/_next/static/media/WarningBack.6205c28f.svg","height":373,"width":330,"blurWidth":0,"blurHeight":0};